import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementBrandMenu } from '@/pages/menu-managements/menus/service';
import { MenuManagementBrandMenuService } from '@/services/BrandMenu/MenuManagementBrandMenuService';
import { MenuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type MenuManagementBrandMenuListParams = MenuManagementListQueryParams;

export type BrandMenuListResponse = {
  brand_menus: MenuManagementBrandMenu[];
  count: number;
};

export const useMenuManagementBrandMenuList = async (
  params: MenuManagementBrandMenuListParams
): Promise<BrandMenuListResponse> => {
  const menuManagementBrandMenuService = new MenuManagementBrandMenuService(
    getClient()
  );
  try {
    const res = await menuManagementBrandMenuService.list(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
